import { t } from "@/i18n-js/instance";
import { useIsPropertiesPanelRevampEnabled } from "@circle-react-shared/BuilderUI/Hooks/useIsPropertiesPanelRevamp";
import { Tab } from "@circle-react-uikit/TabV2";
import { ContentEditor } from "./Content";
import { StylesEditor } from "./Styles";

export const ButtonEditor = () => {
  const isPropertiesPanelV2 = useIsPropertiesPanelRevampEnabled();

  if (isPropertiesPanelV2) {
    return (
      <div className="flex flex-col gap-4 divide-y">
        <ContentEditor />
        <StylesEditor />
      </div>
    );
  }

  return (
    <Tab.Group className="!h-auto">
      <Tab.List className="border-primary gap-x-0 border-b px-6">
        <Tab wrapperClassName="w-full" className="w-full text-sm">
          {t("builder_ui.block_props_category.content")}
        </Tab>
        <Tab wrapperClassName="w-full" className="w-full text-sm">
          {t("builder_ui.block_props_category.design")}
        </Tab>
      </Tab.List>
      <Tab.Panels>
        <Tab.Panel>
          <ContentEditor />
        </Tab.Panel>
        <Tab.Panel>
          <StylesEditor />
        </Tab.Panel>
      </Tab.Panels>
    </Tab.Group>
  );
};
